/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import { useDispatch } from 'react-redux';
import Loader from '../../../../../components/ui-elements/loader';
import OrgUsersList from '../views/organization/users/OrgUsersList';
import OrgUserCreationBtn from '../views/organization/users/OrgUserCreationBtn';
import { useCallback } from 'react';
import { getAllOrgsUsers } from '../../../../../store/reducers/organization/orgUsers/orgUsersAction';

const ManageOrganizationsUsersPage = () => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const fetchOrgsUser = useCallback(async () => {
        try {
            setLoading(true);
            await dispatch(getAllOrgsUsers()).unwrap()
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }, [dispatch]);
    useEffect(() => {
        fetchOrgsUser()
    }, [fetchOrgsUser])
    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Organizations Users'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} />

                    <Grid item xs={12} sm={6} md={6} >
                        <OrgUserCreationBtn />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        {!loading ? <OrgUsersList /> : (<Loader />)}
                    </Grid>

                </Grid>
            </Box>

        </>
    )

}

export default ManageOrganizationsUsersPage; 
